import React from "react";
import { LogOut } from "lucide-react";
import Logo from "@/components/Logo/Logo";
import { PasswordGate } from "@/components/PasswordGate/PasswordGate";
import { AdminContactsView } from "@/components/Admin/AdminContactsView";
import { useGatedResource } from "@/hooks/useGatedResource";
import { useNoIndex } from "@/hooks/useNoIndex";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminContactsPage() {
  useNoIndex();
  const gate = useGatedResource({
    storageKey: "akali_admin_session",
    authUrl: `${API}/admin/auth`,
    logoutUrl: `${API}/admin/logout`,
    resourceUrl: `${API}/contact`,
  });

  if (gate.checking) return <div className="investor-gate" data-testid="admin-checking" />;
  if (!gate.data) {
    return (
      <PasswordGate
        idPrefix="admin"
        eyebrow="ADMIN"
        title="Contatos recebidos"
        description="Área interna. Acesso restrito à equipe Akali AI."
        footnote="Cada acesso é registrado com data, hora e IP."
        gate={gate}
      />
    );
  }

  return (
    <main className="admin-page" data-testid="admin-contacts-page">
      <div className="container">
        <header className="admin-header">
          <Logo size={28} variant="default" />
          <button type="button" className="btn btn-ghost btn-sm" onClick={gate.logout} data-testid="admin-logout">
            <LogOut size={16} />
            Sair
          </button>
        </header>
        <AdminContactsView gate={gate} api={API} />
      </div>
    </main>
  );
}
